import { first } from 'rxjs/operators';

import { OfflineDataFetcher } from '@skinsoft/data-store/src/offline/offline-data-fetcher';
import { Item, ItemDataStore, itemSelectors, Record, recordSelectors, ThesaurusTermDataStore, thesaurusTermSelectors } from '@skinsoft/entity/'
import { matchesRegex } from '@skinsoft/utils';

export class RecordOfflineDataFetcher extends OfflineDataFetcher<Record>{
    constructor(cacheKey: string) {
        super(cacheKey);
    }

    protected async queryTextFilter(entity: Record, queryText: string, locale: string): Promise<boolean> {
        const lowerCaseQueryText: string = queryText.toLowerCase()
        // record title
        const title: string = recordSelectors.recordIdentifier(entity);
        const titleMatch = title ? matchesRegex(queryText, title) : false;

        // record linked object identifier
        const linkedItemId: string = recordSelectors.linkedItemId(entity);
        const item: Item | null = linkedItemId ? await ItemDataStore.getInstance().fetchOne(linkedItemId).pipe(first()).toPromise() : null;
        const itemIdentifier = item ? itemSelectors.identifier(item, locale) : ""
        const itemIdentifierMatch = itemIdentifier ? matchesRegex(lowerCaseQueryText, itemIdentifier.toLowerCase()) : false;

        return titleMatch || itemIdentifierMatch;
    }
}